import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa6";

function WaitingButton({
  message = "Please wait",
  destination,
  proceed = false,
  gamemode = true,
  nextMsg = "Next",
  nextClassName = "standard-btn mb-4 w-48 flex items-center justify-center gap-2 bg-aicom_pink text-white hover:bg-opacity-45 rounded-full",
  className = "standard-btn mb-4",
}) {
  const [dotCount, setDotCount] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev === 3 ? 1 : prev + 1));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const dotString = ".".repeat(dotCount);
  const shouldShowNext = proceed && gamemode;
  // Normalize destination for Link
  const linkProps =
    typeof destination === "string"
      ? { to: destination }
      : { to: { pathname: destination.pathname, state: destination.state } };

  return (
    // <div className="flex flex-col items-center space-y-4">
    <div className="flex flex-col items-center space-y-4 ">
      {!shouldShowNext ? (
        <button className={className}>
          <span className="btn-text-pos-right-lg">{message}</span>
          {dotString}
        </button>
      ) : (
        // <Link {...linkProps} className={nextClassName}>
        <Link {...linkProps}>
          <button className={`${nextClassName} relative`}>
            <span className="btn-text-pos-right-lg">{nextMsg}</span>
            <FaChevronRight className="arrow-pos-right-sm" />
          </button>
        </Link>
      )}
    </div>
  );
}
export default WaitingButton;
